jQuery(document).ready(function ($) {
	if ($("body").hasClass("page-id-6")) {
		const videoElement = $("#endless-effect-video");
		const FULL_PATH_BEFORE_VIDEO_ID = `${TEMPLATE_DIRECTORY}/assets/Video/Homepage/endless-home-video-`;

		// end of the video file names before .mp4
		const VIDEO_IDS = {
			1080: "HD1080p",
			720: "HD720p",
			540: "SD540p",
			360: "SD360p",
			240: "SD240p",
		};

		function setVideoQuality() {
			let width = $(window).width();
			let videoID;

			// 1080p video quality for larger width screens
			if (width >= BOOTSTRAP_BREAKPOINTS.lg) {
				// videoID = VIDEO_IDS[1080];
				videoID = VIDEO_IDS[720]; // set to 720 to see if it fixes bandwidth issue
			} else if (
				// 720p for medium width screens
				width < BOOTSTRAP_BREAKPOINTS.lg &&
				width >= BOOTSTRAP_BREAKPOINTS.md
			) {
				videoID = VIDEO_IDS[720];
			} else {
				// 540p video for smaller screen widths
				videoID = VIDEO_IDS[540];
			}

			const path = `${FULL_PATH_BEFORE_VIDEO_ID + videoID}.mp4`;
			videoElement.attr("src", path);
		}

		setVideoQuality();

		window.addEventListener("resize", () => {
			setVideoQuality();
		});
	}
});
